import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createVNode("svg", {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "512",
  height: "512",
  viewBox: "0 0 512 512"
}, [/*#__PURE__*/_createVNode("title"), /*#__PURE__*/_createVNode("g", {
  id: "icomoon-ignore"
}), /*#__PURE__*/_createVNode("path", {
  fill: "#fff",
  d: "M479.942 64c0.020 0.017 0.041 0.038 0.058 0.058v383.885c-0.017 0.020-0.038 0.041-0.058 0.058h-447.885c-0.020-0.017-0.041-0.038-0.057-0.058v-383.886c0.017-0.020 0.038-0.041 0.057-0.057h447.885zM480 32h-448c-17.6 0-32 14.4-32 32v384c0 17.6 14.4 32 32 32h448c17.6 0 32-14.4 32-32v-384c0-17.6-14.4-32-32-32v0z"
}), /*#__PURE__*/_createVNode("path", {
  fill: "#fff",
  d: "M416 144c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48z"
}), /*#__PURE__*/_createVNode("path", {
  fill: "#fff",
  d: "M448 416h-384v-64l112-192 128 160h32l112-96z"
})], -1);

export default {
  expose: [],
  props: {
    absFill: Boolean,
    src: String
  },
  setup: function setup(__props) {
    var props = __props;
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock("div", {
        class: ["img-fallback", {
          'img-fallback_abs-fill': __props.absFill,
          'img-fallback_default': !__props.absFill
        }]
      }, [_hoisted_1], 2);
    };
  }
};